import { createFileRoute, Outlet } from '@tanstack/react-router';

// relative imports
import ErrorBoundary from '../../components/error-handling/ErrorBoundary';
import LoadingPage from '../../components/shared/page-components/LoadingPage';
import PageBody from '../../components/shared/page-components/PageBody';
import PageHeader from '../../components/shared/page-components/PageHeader';

function StakingPageLayout() {
  // Main staking dashboard page title
  const pageTitle = 'Staking Dashboard';

  return (
    <ErrorBoundary>
      <PageHeader pageTitle={pageTitle} />
      <PageBody>
        <Outlet />
      </PageBody>
    </ErrorBoundary>
  );
}

function StakingPage() {
  // Main staking route - no validatorId needed
  // StakingProvider is handled in index route
  return <StakingPageLayout />;
}

export const Route = createFileRoute('/_authenticated/staking')({
  pendingComponent: () => <LoadingPage loadingPage />,
  component: StakingPage,
  staticData: {
    configPageId: 'staking',
    meta: {
      title: 'Staking Dashboard | Ledgible',
    },
  },
});
